export default {
	path: '/',
	icon: '',
	meta: {
		title: '成人教育'
	},
	children: [
		{
			path: '/AE/signup',
			name:'AdultIndex',
			icon: '',
			ignore: true, //忽略权限校验
			component: () => import('@/views/adultEdu/signup'),
			meta: {
				title: '报名列表'
			}
		},
		{
			path: '/AE/check',
			name:'AdultCheckIndex',
			icon: '',
			ignore: true, //忽略权限校验
			component: () => import('@/views/adultEdu/check'),
			meta: {
				title: '财务审核'
			}
		},
		{
			path: '/AE/pay',
			name:'AdultPayIndex',
			icon: '',
			ignore: true, //忽略权限校验
			component: () => import('@/views/adultEdu/pay'),
			meta: {
				title: '支付订单'
			}
		},
		{
			path: '/AE/refundcw',
			name:'AdultRefundcwIndex',
			icon: '',
			ignore: true, //忽略权限校验
			component: () => import('@/views/adultEdu/refundcw'),
			meta: {
				title: '退费申请-财务'
			}
		},
		{
			path: '/AE/refundxm',
			name:'AdultRefundxmIndex',
			icon: '',
			ignore: true, //忽略权限校验
			component: () => import('@/views/adultEdu/refundxm'),
			meta: {
				title: '退费申请-项目'
			}
		},
		{
			path: '/AE/school',
			name:'adultSchoolIndex',
			icon: '',
			ignore: true, //忽略权限校验
			component: () => import('@/views/adultEdu/school'),
			meta: {
				title: '报考学校'
			}
		}
	]
}
